/* eslint-disable no-multi-str */
// import { detectOS } from '@/global/utils'
/**
 * 此方法是根据wps_sdk.js做的调用方法封装
 * 可参照此定义
 * @param {*} funcs     这是在WPS加载项内部定义的方法，采用JSON格式（先方法名，再参数）
 */

const bUseHttps = false
const WpsInvoke = window.WpsInvoke
function _WpsInvoke(funcs) {
    const info = {}
    info.funcs = funcs
    const func = bUseHttps ? WpsInvoke.InvokeAsHttps : WpsInvoke.InvokeAsHttp
    func(
        WpsInvoke.ClientType.wps, // 组件类型
        'WpsOAAssist', // 插件名，与wps客户端加载的加载的插件名对应
        'dispatcher', // 插件方法入口，与wps客户端加载的加载的插件代码对应，详细见插件代码
        info, // 传递给插件的数据
        function(result) {
            // 调用回调，status为0为成功，其他是错误
            if (result.status) {
                if (bUseHttps && result.status === 100) {
                    WpsInvoke.AuthHttpesCert('请在稍后打开的网页中，点击"高级" => "继续前往"，完成授权。')
                    return
                }
                alert(result.message)
            } else {
                console.log(result.response)
                showresult(result.response || true)
            }
        }
    )
}
/**
 * 该方法封装了发送给WPS客户端的请求，不需要用户去实现
 * 接收消息：WpsInvoke.RegWebNotify（type，name,callback）
 * WPS客户端返回消息： wps.OAAssist.WebNotify（message）
 * @param {*} type 加载项对应的插件类型
 * @param {*} name 加载项对应的名字
 * @param {func} callback 接收到WPS客户端的消息后的回调函数
 */
WpsInvoke.RegWebNotify(WpsInvoke.ClientType.wps, 'WpsOAAssist', function(messageText) {
    var span = window.parent.document.getElementById('webnotifyspan')
    span.innerHTML = messageText
    console.log('wps notify msg:', messageText)
    if (messageText.indexOf('uploadPath') !== -1) {
        document.querySelector('#btnWpsSaved').click()
    }
})

/**
 * 处理WPS加载项的方法返回值
 *
 * @param {*} resultData
 */

function showresult(resultData) {
    // eslint-disable-next-line no-eval
    const json = eval('(' + resultData + ')')
    switch (json.message) {
        case 'GetDocStatus': {
            const docstatus = json.docstatus
            if (typeof docstatus !== 'undefined') {
                const str = '文档保存状态：' + docstatus.saved + '\n文档字数：' + docstatus.words + '\n文档页数：' + docstatus.pages
                alert(str)
            }
        }
    }
}
/**
 * 这是页面中针对代码显示的变量定义，开发者无需关心
 */
window._WpsInvoke = _WpsInvoke

export function wpsInstallAddin(callback) {
    const setting = { name: 'WpsOAAssist', addonType: 'wps', online: 'true', url: `${location.href.split('#')[0]}plugins/wpsjs/wpsoaassit/` }

    window.WpsAddonMgr.getAllConfig((res) => {
        window.WpsAddonMgr.enable(setting, (e) => {
            if (e.status) {
                window.wpsInstalled = false
                callback({ code: 'failure', value: e.message })
            } else {
                window.wpsInstalled = true
                callback({ code: 'success', value: e.message })
            }
        })
    })
}
